export const modals = {
  VIDEO_MODAL: 'VIDEO_MODAL',
  ACCOUNT: 'ACCOUNT',
  EVENTS: 'EVENTS',
  ADD_SPOUSE_PROFILE: 'ADD_SPOUSE_PROFILE',
  SPOUSE_PROFILE: 'SPOUSE_PROFILE',
  ADD_ACCOUNT_OR_SPOUSE: 'ADD_ACCOUNT_OR_SPOUSE',
  SECURELY_ADD_ACCOUNTS: 'SECURELY_ADD_ACCOUNTS',
  INFORMATION_AND_ASSUMPTIONS: 'INFORMATION_AND_ASSUMPTIONS',
  SAVINGS_RUN_OUT: 'SAVINGS_RUN_OUT',
  INCREASE_CONTRIBUTION: 'INCREASE_CONTRIBUTION',
  DELAY_RETIREMENT: 'DELAY_RETIREMENT',
  RETIREMENT_AGE: 'RETIREMENT_AGE',
  RETIREMENT_INCOME: 'RETIREMENT_INCOME',
  CONTRIBUTION_EDUCATION: 'CONTRIBUTION_EDUCATION',
  DELETE_SPOUSE_MODAL: 'DELETE_SPOUSE_MODAL',
  CHART_EDUCATION: 'CHART_EDUCATION',
  TERMED_MODAL: 'TERMED_MODAL',
  CONFIDENCE_NUMBER: 'CONFIDENCE_NUMBER',
  YODLEE_THIRD_PARTY: 'YODLEE_THIRD_PARTY',
  YODLEE_IFRAME: 'YODLEE_IFRAME',
  YODLEE_REDIRECT: 'YODLEE_REDIRECT',
  DOLLAR_VALUE: 'DOLLAR_VALUE',
  EDIT_CHART_DISPLAY_SETTINGS: 'EDIT_CHART_DISPLAY_SETTINGS',
  RIX_ASSUMPTIONS: 'RIX_ASSUMPTIONS',
  LEARN_MORE_MODAL: 'LEARN_MORE_MODAL',
  CONTRIBUTION_SOURCE_MODAL: 'CONTRIBUTION_SOURCE_MODAL',
  CONTRIBUTION_PER_PAYCHECK_MODAL: 'CONTRIBUTION_PER_PAYCHECK_MODAL',
  RIG_SALARY_MODAL: 'RIG_SALARY_MODAL',
  RIG_OTHER_INCOME_MODAL: 'RIG_OTHER_INCOME_MODAL',
};

export const accountModalViews = {
  STRATEGY_MODAL: 'STRATEGY_MODAL',
  ADD_ACCOUNT: 'ADD_ACCOUNT',
  ACCOUNT_INFO: 'ACCOUNT_INFO',
  YOUR_ACCOUNTS: 'YOUR_ACCOUNTS',
  DELETE_ACCOUNT_MODAL: 'DELETE_ACCOUNT_MODAL',
  ERROR_YOUR_ACCOUNTS: 'ERROR_YOUR_ACCOUNTS',
  ERROR_ACCOUNT_INFORMATION: 'ERROR_ACCOUNT_INFORMATION',
};

export const eventModalViews = {
  ADD_FUTURE_EXPENSE: 'ADD_FUTURE_EXPENSE',
  ADD_FUTURE_INCOME: 'ADD_FUTURE_INCOME',
  FUTURE_INCOME_MODAL: 'FUTURE_INCOME_MODAL',
  DELETE_ACCOUNT_MODAL: 'DELETE_ACCOUNT_MODAL',
  DELETE_FUTURE_INCOME: 'DELETE_FUTURE_INCOME',
  DELETE_FUTURE_EXPENSE: 'DELETE_FUTURE_EXPENSE',
};

export const genderOptions: Record<string, string> = {
  M: 'Male',
  F: 'Female',
  P: 'Prefer not to answer',
};

export const derivedAttributes = [
  'isYodleeAccount',
  'accountIndex',
  'hasYodleeAssetAllocationError',
  'hasYodleeAccountTypeError',
  'hasYodleeError',
  'isOverriddenYodleeAccount',
  'isManualAccount',
  'isEditableAccount',
  'accountHolder',
  'error',
  'isPensionAccount',
  'selectedAccountType',
  'isNewAccount',
  'annualSavingsEE',
  'annualSavingsER',
  'contributionIndex',
  'updated',
  'hasError',
  'hasPlanLevelError',
  'showGlobalError',
  'suggestedBreakdown',
  'contributionType',
];

export const postActions = {
  ADD: 'ADD',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
};

export const units = {
  AGE: 'AGE',
  DOLLAR: 'DOL',
};

export const frequency = {
  MONTHLY: 'MLY',
  ANNUAL: 'ANNUAL',
  ONETIME: 'ONET',
};

export const accountTypeCodes = {
  UNKN: 'UNKN',
  NS: 'NS',
  PENSION: 'Pension',
};

export const defaultOption = {
  name: 'Select',
  value: 'select',
};

export const pensionTypes = [
  { label: 'Monthly', value: 'Pension – Monthly' },
  { label: 'Lump Sum', value: 'Pension – Lump Sum' },
];

export const chartTypes = {
  WANT: 'want',
  HAVE: 'have',
};

export const showAsOptions = [
  { name: 'Yearly After-tax Income', value: 'yearlyIncome' },
  { name: 'Monthly After-tax Income', value: 'monthlyIncome' },
];

export const showAsOptionsMobile = [
  { label: 'Yearly After-tax', value: 'yearlyIncome' },
  { label: 'Monthly After-tax', value: 'monthlyIncome' },
];

export const responseStatus = {
  SUCCESS: 'success',
  ERROR: 'error',
};

export const analyticsTracking = {
  RIXActionTileContributions: 'RIXActionTileContributions',
  RIXActionTileContributionsIncrease: 'RIXActionTileContributionsIncrease',
  RIXActionTileContributionsModel: 'RIXActionTileContributionsModel',
  RIXActionTileKnowYourOptions: 'RIXActionTileKnowYourOptions',
  RIXActionTileKnowYourOptionsMoreDetails: 'RIXActionTileKnowYourOptionsMoreDetails',
  RIXActionTileDelayRetirement: 'RIXActionTileDelayRetirement',
  RIXActionTileDelayRetirementDelay: 'RIXActionTileDelayRetirementDelay',
  RIXActionTileAccountSpouse: 'RIXActionTileAccountSpouse',
  RIXAddEditAccount: 'RIXAddEditAccount',
  RIXYourAccountModalLinkAccount: 'RIXYourAccountModalLinkAccount',
  RIXYourAccountModalManuallyEnter: 'RIXYourAccountModalManuallyEnter',
  RIXYourAccountModalDone: 'RIXYourAccountModalDone',
  RIXYourAccountModalEditSave: 'RIXYourAccountModalEditSave',
  RIXYourAccountModalEditCancel: 'RIXYourAccountModalEditCancel',
  RIXDeleteAccount: 'RIXDeleteAccount',
  RIXDeleteFutureIncome: 'RIXDeleteFutureIncome',
  RIXDeleteFutureExpense: 'RIXDeleteFutureExpense',
  RIXAddEditSpouse: 'RIXAddEditSpouse',
  RIXSpouseProfileSave: 'RIXSpouseProfileSave',
  RIXSpouseProfileCancel: 'RIXSpouseProfileCancel',
  RIXSpouseProfileSaveAddAccounts: 'RIXSpouseProfileSaveAddAccounts',
  RIXDeleteSpouseandAccounts: 'RIXDeleteSpouseandAccounts',
  RIXRIOTChart: 'RIXRIOTChart',
  RIXRIOTChartDesiredRetirementNeed: 'RIXRIOTChartDesiredRetirementNeed',
  RIXRIOTChartMakeSavingsLast: 'RIXRIOTChartMakeSavingsLast',
  RIXRIOTChartTodayDollar: 'RIXRIOTChartTodayDollar',
  RIXRIOTChartFutureDollar: 'RIXRIOTChartFutureDollar',
  RIXBOTChart: 'RIXBOTChart',
  RIXBOTChartLiveOffOf: 'RIXBOTChartLiveOffOf',
  RIXBOTChartMakeSavingsLast: 'RIXBOTChartMakeSavingsLast',
  RIXRIGInputTile: 'RIXRIGInputTile',
  RIXRIGInputTileYourSalary: 'RIXRIGInputTileYourSalary',
  RIXRIGInputTileSpouseSalary: 'RIXRIGInputTileSpouseSalary',
  RIXRIGInputTileDone: 'RIXRIGInputTileDone',
  RIXRIGInputTileCancel: 'RIXRIGInputTileCancel',
  RIXContributionsInputTile: 'RIXContributionsInputTile',
  RIXContributionsInputTileDone: 'RIXContributionsInputTileDone',
  RIXContributionsInputTileCancel: 'RIXContributionsInputTileCancel',
  RIXContributionsInputTileUpdateActualContribution: 'RIXContributionsInputTileUpdateActualContribution',
  RIXStrategyBalanceInputTile: 'RIXStrategyBalanceInputTile',
  RIXFutureIncomeInputTile: 'RIXFutureIncomeInputTile',
  RIXRetirementAgeInputTile: 'RIXRetirementAgeInputTile',
  RIXRetirementAgeInputTileDone: 'RIXRetirementAgeInputTileDone',
  RIXRetirementAgeInputTileCancel: 'RIXRetirementAgeInputTileCancel',
  RIXSocialSecurityInputTile: 'RIXSocialSecurityInputTile',
  RIXSocialSecurityInputTileDone: 'RIXSocialSecurityInputTileDone',
  RIXSocialSecurityInputTileCancel: 'RIXSocialSecurityInputTileCancel',
  RIXModelUpdateandShowImpact: 'RIXModelUpdateandShowImpact',
  RIXNeedMoreHelpAdviceFE: 'RIXNeedMoreHelpAdviceFE',
  RIXNeedMoreHelpAdviceOptimizeStrategy: 'RIXNeedMoreHelpAdviceOptimizeStrategy',
  RIXNeedMoreHelpAdviceMorningstar: 'RIXNeedMoreHelpAdviceMorningstar',
  RIXNeedMoreHelpAdviceInvestingBasics: 'RIXNeedMoreHelpAdviceInvestingBasics',
  RIXNeedMoreHelpFWFWBasics: 'RIXNeedMoreHelpFWFWBasics',
  RIXNeedMoreHelpFWSmartDollar: 'RIXNeedMoreHelpFWSmartDollar',
  RIXNeedMoreHelpFWMorganStanley: 'RIXNeedMoreHelpFWMorganStanley',
  RIXNeedMoreHelpFWHilton: 'RIXNeedMoreHelpFWHilton',
  RIXNeedMoreHelpFWMUp: 'RIXNeedMoreHelpFWM_Up',
  RIXNeedMoreHelpVideoConfidenceCheckin: 'RIXNeedMoreHelpVideoConfidenceCheckin',
  RIXNeedMoreHelpVideoSavingsAtWork: 'RIXNeedMoreHelpVideoSavingsAtWork',
  RIXNeedMoreHelpVideoWhatsNext: 'RIXNeedMoreHelpVideoWhatsNext',
  RIXNeedMoreHelpPlanningPage: 'RIXNeedMoreHelpPlanningPage',
  RIXNeedMoreHelpManagedLifetimeIncome: 'RIXNeedMoreHelpManagedLifetimeIncome',
  RIXNeedMoreHelpManagedPayoutProgram: 'RIXNeedMoreHelpManagedPayoutProgram',
  RIXStrategyBalModalCancel: 'RIXStrategyBalModalCancel',
  RIXStrategyBalModalDone: 'RIXStrategyBalModalDone',
  RIXActionTileFutureIncomeCancel: 'RIXActionTileFutureIncomeCancel',
  RIXActionTileFutureIncomeDone: 'RIXActionTileFutureIncomeDone',
  RIXFutureIncomeandExpensesModalAddIncome: 'RIXFutureIncomeandExpensesModalAddIncome',
  RIXFutureIncomeandExpensesModalAddExpense: 'RIXFutureIncomeandExpensesModalAddExpense',
  RIXFutureIncomeandExpensesModalActionCancel: 'RIXFutureIncomeandExpensesModalActionCancel',
  RIXFutureIncomeandExpensesModalActionDone: 'RIXFutureIncomeandExpensesModalActionDone',
  RIXFutureIncomeModalActionCancel: 'RIXFutureIncomeModalActionCancel',
  RIXFutureIncomeModalActionSave: 'RIXFutureIncomeModalActionSave',
  RIXFutureIncomeModalActionDelete: 'RIXFutureIncomeModalActionDelete',
  RIXDeleteFutureIncomeModalActionDelete: 'RIXDeleteFutureIncomeModalActionDelete',
  RIXDeleteFutureIncomeModalActionCancel: 'RIXDeleteFutureIncomeModalActionCancel',
  RIXFutureExpenseModalActionDelete: 'RIXFutureExpenseModalActionDelete',
  RIXFutureExpenseModalActionCancel: 'RIXFutureExpenseModalActionCancel',
  RIXFutureExpenseModalActionSave: 'RIXFutureExpenseModalActionSave',
  RIXDeleteFutureExpenseModalActionCancel: 'RIXDeleteFutureExpenseModalActionCancel',
  RIXDeleteFutureExpenseModalActionDelete: 'RIXDeleteFutureExpenseModalActionDelete'
};

export const charts = {
  RETIREMENT_INCOME: analyticsTracking.RIXRIOTChart,
  SAVINGS_BALANCE: analyticsTracking.RIXBOTChart,
};

export const dollarTypes = {
  TODAYS_DOLLARS: 'todaysDollars',
  FUTURE_DOLLARS: 'futureDollars',
};

export const dollarTypeOptions = [
  { name: "today's dollars", value: 'todaysDollars', id: analyticsTracking.RIXRIOTChartTodayDollar },
  { name: 'future dollars', value: 'futureDollars', id: analyticsTracking.RIXRIOTChartFutureDollar },
];

export const dollarTypeOptionsMobile = [
  { label: 'Show in today’s dollars', value: 'todaysDollars', id: analyticsTracking.RIXRIOTChartTodayDollar },
  { label: 'Show in future dollars', value: 'futureDollars', id: analyticsTracking.RIXRIOTChartFutureDollar },
];

export const videoTileHeader: any = {
  RWC: 'Plan smart with a Confidence Check-In® Conversation.',
  NON_RWC: 'Find out where your savings stand.',
  TERMINATED: 'Explore your options for your old employer’s plan.',
};

export const contributionTypes = {
  EE: 'Employee',
  ER: 'Employer',
  BOTH: 'Both',
  NONE: 'None',
};
